// Authentication Logic - Updated

const Auth = {
    async register(formData) {
        const email = formData.get('email');
        const password = formData.get('password');
        const confirmPassword = formData.get('confirmPassword');
        const fullName = formData.get('full_name');
        const contactNumber = formData.get('contact_number');
        const isbnNumber = formData.get('isbn_number');
        const country = formData.get('country');
        const state = formData.get('state');
        const school = formData.get('school');
        const grade = formData.get('grade');
        const actAttemptDate = formData.get('act_attempt_date');
        
        // Validation
        if (!email || !password || !fullName || !contactNumber || !isbnNumber || !country || !state || !school || !grade || !actAttemptDate) {
            return { success: false, message: 'Please fill in all fields' };
        }
        
        // Validate contact number format
        const phoneRegex = /^\+\d{10,15}$/;
        if (!phoneRegex.test(contactNumber)) {
            return { success: false, message: 'Contact number must start with + followed by 10-15 digits (e.g., +1234567890)' };
        }
        
        // Validate ISBN format (13 digits only)
        if (!/^\d{13}$/.test(isbnNumber)) {
            return { success: false, message: 'ISBN must be exactly 13 digits (numbers only)' };
        }
        
        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return { success: false, message: 'Please enter a valid email address' };
        }
        
        if (password.length < 6) {
            return { success: false, message: 'Password must be at least 6 characters' };
        }
        
        if (password !== confirmPassword) {
            return { success: false, message: 'Passwords do not match' };
        }
        
        // Prepare user data
        const userData = {
            email,
            password,
            full_name: fullName,
            contact_number: contactNumber,
            isbn_number: isbnNumber,
            country,
            state,
            school,
            grade,
            act_attempt_date: actAttemptDate
        };
        
        // Call API
        showLoading('Creating your account...');
        const result = await SheetsAPI.register(userData);
        hideLoading();
        
        if (result.success) {
            // Store user session
            setUserSession({
                uid: result.uid,
                email: result.email,
                full_name: result.full_name,
                contact_number: result.contact_number,
                country: result.country,
                state: result.state,
                school: result.school,
                grade: result.grade,
                act_attempt_date: result.act_attempt_date
            });
        }
        
        return result;
    },
    
    // Login user (only email and password required)
    async login(formData) {
        const email = formData.get('email');
        const password = formData.get('password');
        
        // Validation
        if (!email || !password) {
            return { success: false, message: 'Please enter email and password' };
        }
        
        // Call API
        showLoading('Logging in...');
        const result = await SheetsAPI.login(email, password);
        hideLoading();
        
        if (result.success) {
            // Store user session
            setUserSession({
                uid: result.uid,
                email: result.email,
                full_name: result.full_name,
                contact_number: result.contact_number,
                isbn_number: result.isbn_number,
                country: result.country,
                state: result.state,
                school: result.school,
                grade: result.grade,
                act_attempt_date: result.act_attempt_date
            });
        }
        
        return result;
    },
    
    // Logout user
    logout() {
        clearUserSession();
        window.location.href = '/pages/act-login';
    }
};